import { API, METHODS } from '../constants';
import { fetchData } from '../utils';

export const vendorReport = async ({ data = {} }) => {
  const url = API.REPORT;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};

export const exportWipReport = async ({ data = {} }) => {
  const url = API.EXPORT_WIP_REPORT;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};